import React, { FC } from 'react';
import { useMarkPageLoaded } from 'omni-package-react-core';
import MfaCodeValidation from '../../components/MfaCodeValidation';

export interface MfaEmailCodeStepProps {
}

const MfaEmailCodeStep: FC<MfaEmailCodeStepProps> = () => {
  useMarkPageLoaded();
  return (
    <MfaCodeValidation
      method="email"
      informationType="email"
    />
  );
};

export default MfaEmailCodeStep;
